import { render, staticRenderFns } from "./AddTagToDocumentDialog.vue?vue&type=template&id=47780aaa"
import script from "./AddTagToDocumentDialog.vue?vue&type=script&lang=js"
export * from "./AddTagToDocumentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47780aaa')) {
      api.createRecord('47780aaa', component.options)
    } else {
      api.reload('47780aaa', component.options)
    }
    module.hot.accept("./AddTagToDocumentDialog.vue?vue&type=template&id=47780aaa", function () {
      api.rerender('47780aaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/document-tags/AddTagToDocumentDialog.vue"
export default component.exports